import { useState } from 'react';
import { ChevronRight } from 'lucide-react';

import { Button } from '@/components/ui/button';
import PlanningStepper from 'components/IAP/planningView/PlanningStepper';
import { PLANNING_PHASES } from 'components/IAP/planningView/USCGPage';
import {
  readStepperOpenPreference,
  writeStepperOpenPreference,
} from 'components/IAP/planningView/stepperOpenPreference';

/**
 * The Planning P stepper down the left of a seat workspace, collapsible to the
 * same rail Planning P uses.
 */
export function SeatPlanningStepper({
  phase,
  onPhaseChange,
}: {
  phase: number;
  onPhaseChange: (phase: number) => void;
}) {
  const [open, setOpen] = useState(readStepperOpenPreference);
  const setStepperOpen = (next: boolean) => {
    setOpen(next);
    writeStepperOpenPreference(next);
  };

  if (open) {
    return (
      <PlanningStepper
        planningPhases={PLANNING_PHASES}
        currentPhase={phase}
        updatePhase={onPhaseChange}
        isOpen
        onHide={() => setStepperOpen(false)}
      />
    );
  }

  return (
    <div
      className="dark planning-stepper-rail"
      data-tour="psc-planning-stepper"
    >
      <Button
        type="button"
        variant="outline"
        size="icon-sm"
        className="planning-stepper-rail__toggle tw:rounded-none tw:border-0 tw:border-b tw:border-border tw:shadow-none"
        onClick={() => setStepperOpen(true)}
        aria-label="Expand planning stepper"
        title="Expand planning stepper"
      >
        <ChevronRight className="tw:h-4 tw:w-4" aria-hidden />
      </Button>
      <PlanningStepper
        planningPhases={PLANNING_PHASES}
        currentPhase={phase}
        updatePhase={onPhaseChange}
        isOpen={false}
      />
    </div>
  );
}
